import { ChangeDetectionStrategy, Component, input, output, OutputEmitterRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { IconSize, IconColor } from './models';

@Component({
  selector: 'rp-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: inline-flex;' },
  imports: [MatIcon],
})
export class IconComponent {
  color = input<IconColor>(IconColor.DEFAULT);
  // Corresponds to svg file name inside /icons/svg-icons.
  iconName = input.required<string>();

  disabled = input(false);
  size = input<IconSize>('m');

  iconClick: OutputEmitterRef<MouseEvent> = output<MouseEvent>();

  onIconClick(event: MouseEvent): void {
    if (this.disabled()) {
      return event.stopPropagation();
    }

    this.iconClick.emit(event);
  }
}
